import { configureStore } from '@reduxjs/toolkit'
import Content from './contentSlices/ContentSlices'
import Header from './headerSlices/HeaderSlices'
import Filter from './filterSlices/FilterSlices'
import Movie from './movieSlices/MovieSlices'
import { useDispatch } from 'react-redux'

export const store = configureStore({
    reducer: {
        Content,
        Header,
        Movie,
        Filter,
    },
})

export type RootState = ReturnType<typeof store.getState>

type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
